// Login Page Component

import auth from '../auth.js';

export function renderLoginPage() {
  return `
    <div class="login-container">
      <div class="login-box">
        <h1>🔖 Bookmark Manager</h1>
        <p class="subtitle">Organisieren Sie Ihre Lesezeichen sicher und effizient</p>

        <div class="login-buttons">
          <button id="login-google" class="btn btn-google">
            <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              <path fill="none" d="M0 0h48v48H0z"/>
            </svg>
            Mit Google anmelden
          </button>

          <button id="login-microsoft" class="btn btn-microsoft">
            <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            Mit Microsoft anmelden
          </button>
        </div>

        <div class="features">
          <h3>Features</h3>
          <ul>
            <li>✓ OAuth2 Social Login (Google/Microsoft)</li>
            <li>✓ Bookmark-Verwaltung mit Kategorien und Tags</li>
            <li>✓ Volltext-Suche und Filter</li>
            <li>✓ Import/Export (HTML, JSON)</li>
          </ul>
        </div>
      </div>
    </div>
  `;
}

export function initLoginPage() {
  document.getElementById('login-google')?.addEventListener('click', () => {
    auth.loginWithGoogle();
  });

  document.getElementById('login-microsoft')?.addEventListener('click', () => {
    auth.loginWithMicrosoft();
  });
}
